// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Returns48Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Returns48: FC<Returns48Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="48"
            height="49"
        >
            <path
                stroke="#000"
                d="m13.346 19.23 5.347 5.346-1.393 1.393-8.593-8.593L17.3 8.783l1.393 1.393-5.347 5.346-.853.854H28.4c3.042 0 5.644 1.02 7.834 3.065 2.181 2.039 3.266 4.54 3.266 7.535s-1.084 5.496-3.266 7.535c-2.19 2.045-4.792 3.065-7.834 3.065H13.45v-2h15c2.456 0 4.586-.82 6.364-2.457 1.786-1.645 2.686-3.704 2.686-6.143 0-2.439-.9-4.498-2.686-6.143-1.778-1.637-3.908-2.457-6.364-2.457H12.493l.853.854Z"
            />
        </svg>
    );
};

export default Returns48;
